import roles from "../consts/roles";
import useMe from "./useMe";

const useEnabledFinishedStatus = () => {
    const {role} = useMe();
    return role === roles.CEO || role === roles.ADMIN;
};

export default useEnabledFinishedStatus;